export const LANGUAGE_ACTION = 'LANGUAGE_ACTION';
export const LANGUAGE_SUCCESS_ACTION = 'LANGUAGE_SUCCESS_ACTION';
export const LANGUAGE_FAILURE_ACTION = 'LANGUAGE_FAILURE_ACTION';
